<template>
  <div class="am-tabs-arrow-scroller">
    <arrow v-if="arrowScroll" @click="scrollToFirst" icon="keyboard_arrow_left" />
    <div class="am-tabs-arrow-scroller--tabs">
      <slot />
    </div>
    <arrow v-if="arrowScroll" @click="scrollToLast" icon="keyboard_arrow_right" />
  </div>
</template>

<script>
import Arrow from "./Arrow.vue";

export default {
  components: {
    Arrow
  },
  props: {
    arrowScroll: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    scrollToLast() {
      this.$emit("scrollToLast");
    },
    scrollToFirst() {
      this.$emit("scrollToFirst");
    }
  }
};
</script>
